import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector } from "redux-form";
import { Redirect } from 'react-router-dom';
import { withRouter } from 'react-router'
import { connect } from "react-redux";
import axios from "axios";
import SectionHeader from "./SectionHeader";
import Address from "../common/address";
import ProductList from "./products";
import Borrower from "./borrower";
import Title from "./Title";
import Instruction from "./AddInstruction";
import Banner from "../common/banner";
import appConfig from '../../config/config';
import PageSpinner from "../PageSpinner";

import {
    Card, Button, CardImg, CardTitle, CardText, CardColumns,
    CardSubtitle, CardBody
} from 'reactstrap';
import CardHeader from "reactstrap/lib/CardHeader";


const submitOrder = async (values, token, user) => {
    var v = JSON.stringify({
        ...values, 
        Action: "New",
        UserName: user
    }); 
    var a = await axios.post(
        appConfig.apiGateway.submitUrl,
        v,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }
    );
    return a.data;
}
class OrderCreateForm extends Component {
    constructor(...args) {
        super(...args);
        this.state = {
            showBanner: false, message: '', IsLoading: false
        };
    }
    closeBanner = () => {
        this.setState({
            showBanner: false, message: '', IsLoading:false
        });
    };
    submit = (values) => {
        console.log("order submitted")
        var c = this.props.history;
        var b = submitOrder(values,
            this.props.session.session.credentials.accessToken,
            this.props.session.session.user.email);
        this.setState({ ...this.state, IsLoading:true });
        b.then((s) => {
            this.setState({ ...this.state, IsLoading: false });
            var myObject = s.body;
            if (!myObject.Status) {
                this.setState({ showBanner: true, message: myObject.Message });
            }
            else this.props.complete(myObject);

        },(r) => {
            console.log(r)
            this.setState({ showBanner: true, message: "AVM took longer than expected time. Please wait for few minutes and search for the order by loan number." });
            this.setState({ ...this.state, IsLoading: false });
        })
    }


    render() {
       if ( !this.props.session.isLoggedIn)
        return <Redirect to="/order-create" />
        if (this.state.IsLoading)
            return (
                <PageSpinner />
                );
        else
        return (
            <>
                {this.state.showBanner && (<Banner Close={this.closeBanner} message={this.state.message} />)}
                <form onSubmit={this.props.handleSubmit(this.submit)} style={{ marginLeft:"5%", marginRight:"5%" }}>
                    <div className="form-row mb-3">
                        <Card className="col-12">
                                <CardHeader><strong>Property Address</strong></CardHeader>
                            <CardBody>
                                <Address UseAddress={this.props.UseAddress} />
                            </CardBody>
                        </Card>
                    </div>

                    <div className="form-row">
                        <Card className="col-12 mb-3">
                                <CardHeader><strong>Products</strong></CardHeader>
                            <CardBody>
                                <ProductList Role={this.props.session.session.user}/>
                            </CardBody>
                        </Card>
                    </div>

                     {this.props.Product && (
                        <div className="form-row">
                            <Card className="col-12 mb-3">
                                    <CardHeader><strong>Addtional Field(s)</strong></CardHeader>
                                <CardBody>
                                    <Title />
                                </CardBody>
                            </Card>

                        </div>
                    )} 

                    <div className="form-row">
                        <Card className="col-12 mb-3">
                                <CardHeader><strong>Borrower</strong></CardHeader>
                            <CardBody>
                                <Borrower prefix="Borrower" />
                            </CardBody>
                        </Card>

                    </div>
                    <div className="form-row">
                        <Card className="col-12 mb-3">
                                <CardHeader><strong>Agent/Contact</strong></CardHeader>
                            <CardBody>
                                <Borrower prefix="Agent" />
                            </CardBody>
                        </Card>
                    </div>
                    <div className="form-row">
                        <Card className="col-12 mb-3">
                                <CardHeader><strong>Additional Instructions</strong></CardHeader>
                            <CardBody>
                                <Instruction />
                            </CardBody>
                        </Card>
                    </div>

                    <div className="form-row">
                        <Card className="col-12 mb-3">
                            <CardBody>
                                <div className="text-right">
                                    <Button color="primary" type="submit" disabled={this.props.pristine ||
                                         this.props.submitting} className="mr-3">Create</Button>
                                    <Button type="button">Cancel</Button>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </form>
            </>

        );
    };
};

const validate = (formValues) => {
    const errors = {};
    if (!formValues.Address) {
        errors.Address = "Please select address ";
    }
    if (!formValues.BorrowerLastName) {
        errors.BorrowerLastName = "Please provide borrower last name";
    }
    if (!formValues.LoanId) {
        errors.LoanId = "Please provide Loan Id";
    }
    if (formValues.BorrowerEmail && (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formValues.BorrowerEmail))) {
        errors.BorrowerEmail = 'Invalid email address';
    }
    if (formValues.AgentEmail && (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formValues.AgentEmail))) {
        errors.AgentEmail = 'Invalid email address';
    }
    return errors;
}

var orderform = reduxForm({
    form: 'orderForm',
    validate
})(OrderCreateForm);

const selector = formValueSelector('orderForm')

orderform = connect(state => {
    const Product = selector(state, 'Appraisal');
    const UseAddress = selector(state, 'UseAddress');
    return {
        Product,
        UseAddress,
        session: state.session
    }
})(orderform);

export default orderform;
